import axios from "axios";
import {environment} from "../environments/environment";
import {keycloak} from "./keycloak";

const api = axios.create({
    baseURL: environment.apiUrl,
});

api.interceptors.request.use((config: any) => {
    const token = sessionStorage.getItem("token");
    if (token) {
        config.headers = config.headers ?? {};
        config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
});

let sessionExpiredHandled = false;

api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401 && !sessionExpiredHandled) {
            sessionExpiredHandled = true;
            sessionStorage.removeItem("token");
            keycloak.logout({redirectUri: window.location.origin});
        }
        return Promise.reject(error);
    }
);

export {api};
